module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-winter-2020-b4ea4b4aa826b7d44a9a0e387eb2eac7.jpg";